<template>
  <modal-template>
    <template #header>
      <div style="width:100%;float:left;">
        <div class="modal-header-style">
          <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
            <span>*** PAST CUTOFF TIME FOR THIS ORDER ***</span>
          </div>
          <div style="float:right;">
            <label class="action-icon-style" v-on:click="$emit('close', true)">
              <font-awesome-icon icon="xmark" size="xl"/>
              <span style="display: block;">close</span>
            </label>
          </div>
        </div>
        <div style="width:100%;float:left;">
          <div style="font-size:larger;font-weight:bold;">
            <sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
          </div>
          <div>serviced by <sup>[{{ account.dairyId }}]</sup> {{ account.dairyName }}</div>
        </div>
      </div>
    </template>
    <template #body>
      <div style="font-size:large;font-weight:bold;text-align:center;color:red;">
        <span>Please contact your Dairy with your order information.</span>
      </div>
    </template>
    <template #footer>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'SubmitPastCutOff',
  props: ['account'],
  emits: ['close'],
  data: function () {
    return {
    }
  },
  components: {
    ModalTemplate,
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
